/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/assessment/assessment',['require','jquery','underscore','backbone','core/templates','core/base-screen','screens/assessment/question','modules/components/feedback'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var templates = require('core/templates');
  var BaseScreen = require('core/base-screen');
  var Question = require('screens/assessment/question');
  var Feedback = require('modules/components/feedback');

  /*****************************************************************************************************************///}

  var Assessment = BaseScreen.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    options: {
      shuffleQuestions: false,
      shuffleResponses: false,
      maxAttempts: 2,
      remediation: 'immediate' // immediate, recycle, none
    },

    regions: {
      question: '.question-holder',
      feedback: '.feedback-holder'
    },

    questions: [],
    currentQuestion: null,
    feedback: null,
    disabled: false,
    questionTmpl: null,
    questionCorrect: 0,
    totalQuestions: 0,
    currentQuestionIndex: 0,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      //console.log('MultipleChoice::initialize');

      this.questionTmpl = templates['screens/assessment/question'];
    },

    setInterface: function()
    {
      //console.log('BaseScreen::setInterface');

      var ui = { 'help': false, 'caption': true, 'badge': false, 'next': false, 'back': false, 'home': true };

      // custom ui settings
      _.assign(ui, this.page.get('ui'));

      this.radio.trigger('ui.update', ui);
    },

    onShow: function()
    {
      //console.log('page', this.page.collection.parent.get('percBronze'));
      //this.playMedia();
      this.questionCorrect = 0;
      this.questions = new Backbone.Collection(this.model.get('questions'));
      this.page.set('maxPoints', this.questions.length);
      //this.page.set('earnedPoints', 0);

      var self = this;
      this.questions.each(function(question)
      {
        question.set('attempts', self.options.maxAttempts);
      });

      if (this.options.shuffleQuestions)
        this.questions.reset(this.questions.shuffle());

      this.showFeedback(this.model.get('feedback').intro, $.proxy(this.setupQuestion, this));

      //this.setupQuestion();
    },

    updateCounter: function()
    {
      this.$el.find('#text .counter-text').html('Question: ' + this.currentQuestionIndex + ' of ' + this.page.get('maxPoints'));
    },

    setupQuestion: function()
    {
      //console.log('MultipleChoice::setupQuestion');
      if (!this.question)
        return;

      this.currentQuestionIndex++;

      if (this.questions.length)
      {
        this.currentQuestion = this.questions.shift();

        var options = new Backbone.Collection(this.currentQuestion.get('options'));

        var questionView = new Question({ model: this.currentQuestion, collection: options, options: this.options, template: this.questionTmpl });

        questionView.on('option:pressed', this.itemPressed, this);
        this.question.show(questionView);
        this.updateCounter();
        var media = this.currentQuestion.get('media');
        if (media && !media.played)
        {
          this.playMedia({ media: media });
          media.played = true;
        }
      }
      else
      {
        this.finish();
      }
    },

    itemPressed: function(option, $el)
    {
      this.question.currentView.disable();
      //console.log(option);

      if (option.get('correct')) // followup when option is incorrect
      {
        this.questionCorrect++;
        $el.addClass('correct');
      }
      else
      {
        $el.addClass('incorrect');
      }

      _.delay($.proxy(this.setupQuestion, this), 200);
      //this.checkFeedback(option);

      return false;
    },

    checkFeedback: function(option)
    {
      var feedback = option.get('feedback');
      if (feedback)
      {
        var layout = (option.get('correct')) ? 'correct' : 'incorrect';
        this.showFeedback(feedback, this.setupQuestion, { layout: layout });
      }
      else
      {
        this.setupQuestion();
      }
    },

    showFinalFeedback: function()
    {
      var feedback = this.model.get('feedback');

      this.question.empty();

      if (!feedback)
        return;
      var $perc = this.questionCorrect / this.model.get('questions').length;
      this.page.set('earnedPoints', this.questionCorrect);
      ////console.log('final', this.questionCorrect, this.model.get('questions'), $perc);
      var $feedback = _.cloneDeep(feedback['outro-fail']);
      var $layout = 'final fail';

      if ($perc >= this.page.collection.parent.get('percBronze'))
      {
        $layout = 'final pass';
        $feedback = _.cloneDeep(feedback['outro-pass']);
        this.page.finish();
      }
      $feedback.text = $feedback.text.replace('{score}', Math.round($perc * 100));

      this.showFeedback($feedback, null, { layout: $layout });
    },

    showFeedback: function(feedback, onDestroy, params)
    {
      onDestroy = onDestroy || _.noop;
      params = params || { };

      if (!feedback)
      {
        //console.log('Feedback not found.');
        onDestroy();
        return;
      }

      var model = new Backbone.Model(feedback);

      _.each(params, function(value, key)
      {
        model.set(key, value);
      });

      //console.log(params);
      //console.log(model);

      var feedbackView = new Feedback({ model: model });
      feedbackView.on('destroy', onDestroy, this);
      this.feedback.show(feedbackView);
    },

    finish: function()
    {
      //BaseScreen.prototype.finish.apply(this, arguments);

      this.radio.trigger('screen.complete', this);
      //console.log('MultipleChoice::finish');

      this.showFinalFeedback();
    }

  /*****************************************************************************************************************///}

  });

  return Assessment;

});

